/**
 * Shared constants for VTDR Vet Schedule application
 */

const API_CONFIG = {
  DEFAULT_APPOINTMENT_DURATION: 15, // minutes
  DEFAULT_PORT: 3993,
};

const APPOINTMENT_TYPES = {
  CONSULTATION: 'consultation',
  CHECKUP: 'checkup',
  SURGERY: 'surgery',
  VACCINATION: 'vaccination',
  EMERGENCY: 'emergency',
};

const CONSULT_TYPES = {
  CONSULT: {
    name: "Consult",
    color_class: "red",
    font_icon: "local_hospital",
    is_service: true,
    has_report: true,
    has_billings: true,
    has_qboclass: true,
    speciestypes: ["SPECIESTYPE_SA", "SPECIESTYPE_LA", "SPECIESTYPE_EQ"],
    consult_status: ["CONSULTSTATUS_UNSCHEDULED", "CONSULTSTATUS_SCHEDULED", "CONSULTSTATUS_WAITING", "CONSULTSTATUS_INPROGRESS", "CONSULTSTATUS_PAYMENT", "CONSULTSTATUS_COMPLETED", "CONSULTSTATUS_CANCELLED"],
  },
  CLAIMS: {
    name: "Claims",
    color_class: "blue",
    font_icon: "add_moderator",
  },
  NOTES: {
    name: "Notes",
    color_class: "black",
    font_icon: "message",
  },
  REPEAT: {
    name: "Repeat",
    color_class: "red",
    font_icon: "local_hospital",
    is_service: true,
    has_report: true,
    has_billings: true,
    has_qboclass: true,
    speciestypes: ["SPECIESTYPE_SA", "SPECIESTYPE_LA", "SPECIESTYPE_EQ"],
    consult_status: ["CONSULTSTATUS_UNSCHEDULED", "CONSULTSTATUS_SCHEDULED", "CONSULTSTATUS_WAITING", "CONSULTSTATUS_INPROGRESS", "CONSULTSTATUS_PAYMENT", "CONSULTSTATUS_COMPLETED", "CONSULTSTATUS_CANCELLED"],
  },
  TBTEST: {
    name: "TB Test",
    color_class: "blue",
    font_icon: "feedback",
    is_service: true,
    has_report: true,
    has_billings: true,
    has_qboclass: true,
    speciestypes: ["SPECIESTYPE_LA"],
    consult_status: ["CONSULTSTATUS_UNSCHEDULED", "CONSULTSTATUS_SCHEDULED", "CONSULTSTATUS_WAITING", "CONSULTSTATUS_INPROGRESS", "CONSULTSTATUS_PAYMENT", "CONSULTSTATUS_COMPLETED", "CONSULTSTATUS_CANCELLED"],
  },
  EXTERNAL: {
    name: "External",
    color_class: "grey",
    font_icon: "feedback",
    is_service: false,
    has_report: false,
    has_billings: true,
    has_qboclass: false,
    speciestypes: ["SPECIESTYPE_SA", "SPECIESTYPE_LA", "SPECIESTYPE_EQ"],
    consult_status: ["CONSULTSTATUS_COMPLETED"],
  },
  ESTIMATE: {
    name: "Estimate",
    color_class: "grey",
    font_icon: "euro_symbol",
    is_service: false,
    has_report: false,
    has_billings: true,
    has_qboclass: false,
    speciestypes: ["SPECIESTYPE_SA", "SPECIESTYPE_LA", "SPECIESTYPE_EQ"],
    consult_status: ["CONSULTSTATUS_COMPLETED"],
  },
  SURGERY: {
    name: "Surgery",
    color_class: "red",
    font_icon: "feedback",
    is_service: true,
    has_report: true,
    has_billings: true,
    has_qboclass: false,
    speciestypes: ["SPECIESTYPE_SA", "SPECIESTYPE_LA", "SPECIESTYPE_EQ"],
    consult_status: ["CONSULTSTATUS_UNSCHEDULED", "CONSULTSTATUS_SCHEDULED", "CONSULTSTATUS_WAITING", "CONSULTSTATUS_INPROGRESS", "CONSULTSTATUS_PAYMENT", "CONSULTSTATUS_COMPLETED", "CONSULTSTATUS_CANCELLED"],
  },
  LABS: {
    name: "Labs",
    color_class: "brown",
    font_icon: "assignment",
    is_service: true,
    has_report: true,
    has_labs: true,
    has_qboclass: false,
    speciestypes: ["SPECIESTYPE_SA", "SPECIESTYPE_LA", "SPECIESTYPE_EQ"],
    consult_status: ["CONSULTSTATUS_COMPLETED", "CONSULTSTATUS_CANCELLED"],
  },
  HOSPITAL: {
    name: "Hospital Day",
    color_class: "red",
    font_icon: "home",
    is_service: true,
    has_report: true,
    has_billings: true,
    has_qboclass: true,
    speciestypes: ["SPECIESTYPE_SA", "SPECIESTYPE_LA", "SPECIESTYPE_EQ"],
    consult_status: ["CONSULTSTATUS_INPROGRESS", "CONSULTSTATUS_COMPLETED", "CONSULTSTATUS_CANCELLED"],
  },
  QUOTATION: {
    name: "Quotation",
    color_class: "vetdrive-bg-brown",
    font_icon: "format_quote",
    is_sale: true,
    is_service: false,
    has_report: false,
    has_labs: false,
    has_qboclass: true,
    speciestypes: ["SPECIESTYPE_SA", "SPECIESTYPE_LA", "SPECIESTYPE_EQ"],
    consult_status: ["CONSULTSTATUS_PAYMENT", "CONSULTSTATUS_COMPLETED", "CONSULTSTATUS_CANCELLED"],
  },
  PURCHASE: {
    name: "Purchase",
    color_class: "vetdrive-bg-green",
    font_icon: "shopping_cart",
    is_sale: true,
    is_service: false,
    has_report: false,
    has_labs: false,
    has_qboclass: true,
    speciestypes: ["SPECIESTYPE_SA", "SPECIESTYPE_LA", "SPECIESTYPE_EQ"],
    consult_status: ["CONSULTSTATUS_PAYMENT", "CONSULTSTATUS_COMPLETED", "CONSULTSTATUS_CANCELLED"],
  },
  BALANCE: {
    name: "Opening Balance",
    is_service: false,
    has_report: false,
    has_labs: false,
    has_qboclass: false,
    consult_status: ["CONSULTSTATUS_COMPLETED", "CONSULTSTATUS_CANCELLED"],
  },
  APPOINTMENTSLOTS: {
    name: "Appointment Slots",
    is_background: true,
    is_available: true,
    has_qboclass: false,
    consult_status: ["CONSULTSTATUS_SCHEDULED", "CONSULTSTATUS_CANCELLED"],
  },
  OUTOFOFFICE: {
    name: "Out of Office",
    is_background: true,
    is_available: false,
    has_qboclass: false,
    consult_status: ["CONSULTSTATUS_SCHEDULED", "CONSULTSTATUS_CANCELLED"],
  },
  REMINDER: {
    name: "Reminder",
    is_background: true,
    is_available: true,
    has_qboclass: false,
    consult_status: ["CONSULTSTATUS_SCHEDULED", "CONSULTSTATUS_CANCELLED"],
  },
  ONLINEBOOKING: {
    name: "Online Booking",
    is_background: true,
    is_available: true,
    has_qboclass: false,
    consult_status: ["CONSULTSTATUS_SCHEDULED", "CONSULTSTATUS_CANCELLED"],
  },
  CANCELLEDBACKGROUNDEVENT: {
    name: "Cancelled Background Event",
    is_background: true,
    is_available: true,
    has_qboclass: false,
    consult_status: ["CONSULTSTATUS_SCHEDULED", "CONSULTSTATUS_CANCELLED"],
  },
  CUSTOMBGEVENT: {
    name: "Custom BG Event",
    is_background: true,
    is_available: true,
    has_qboclass: false,
    consult_status: ["CONSULTSTATUS_SCHEDULED", "CONSULTSTATUS_CANCELLED"],
  },
};

const SPECIES = {
  DOG: 'dog',
  CAT: 'cat',
  BIRD: 'bird',
  RABBIT: 'rabbit',
  OTHER: 'other',
};

/**
 * Get human-readable name for a consult type enum value
 * @param {string} enumValue - The enum value like "CONSULTTYPE_CONSULT"
 * @returns {string} Human-readable name or the original value if not found
 */
function getConsultTypeName(enumValue) {
  if (!enumValue || typeof enumValue !== 'string') {
    return enumValue;
  }

  // Remove the "CONSULTTYPE_" prefix if present
  const typeKey = enumValue.replace(/^CONSULTTYPE_/, '');

  // Look up in CONSULT_TYPES
  const consultType = CONSULT_TYPES[typeKey];
  return consultType ? consultType.name : enumValue;
}

module.exports = {
  API_CONFIG,
  APPOINTMENT_TYPES,
  CONSULT_TYPES,
  SPECIES,
  getConsultTypeName,
};

